module.exports = __webpack_public_path__ + "static/media/daily reports.49fd35a0.svg";